<div class="scroll-row-frame">
  <div
    #track
    class="scroll-row-track"
    [class.can-drag]="canScrollLeft() || canScrollRight()"
    (dragstart)="$event.preventDefault()"
  >
    <div #content class="scroll-row-content">
      <ng-content />
    </div>
  </div>

  @if (canScrollLeft()) {
    <button type="button" class="scroll-row-arrow left" tabindex="-1" aria-label="Scroll left" (click)="scroll(-1)">
      <svg
        viewBox="0 0 24 24"
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path d="m15 18-6-6 6-6" />
      </svg>
    </button>
  }
  @if (canScrollRight()) {
    <button type="button" class="scroll-row-arrow right" tabindex="-1" aria-label="Scroll right" (click)="scroll(1)">
      <svg
        viewBox="0 0 24 24"
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path d="m9 18 6-6-6-6" />
      </svg>
    </button>
  }
</div>
